export function getRecentQueriesInitialState() {
    return {
        queries: [],
        maxLength: 10,
    };
}
